import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const isCancelled = searchParams.get("state") === "cancel";

  return (
    <main
      className="content-page checkout-success-page successDiv"
      id="main-content"
    >
      <div className="content-page__inner success-container">
        <section
          className="checkout-success-page__card modal-content"
          aria-labelledby="order-complete-title"
        >
          <div className="checkmark-circle" aria-hidden="true">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <p className="content-page__eyebrow">{isCancelled ? "Payment cancelled" : "Order complete"}</p>
          <h1 className="content-page__title" id="order-complete-title">
            {isCancelled ? "Your payment was not completed" : "Thank you for your order"}
          </h1>
          <p className="checkout-success-page__reference">{isCancelled ? "No charge was completed. You may return to the shop and try again." : "Your payment was successful and your order has been confirmed."}</p>
          <div className="checkout-success-page__status" role="status">
            <h2>What happens next?</h2>
            <p>
              {isCancelled ? `Your ${siteConfig.brandName} bag can be rebuilt from the shop.` : "A confirmation and delivery updates will be sent to the email used at checkout."}
            </p>
          </div>
          <div className="checkout-success-page__actions">
            <Link className="checkout-success-page__button" to="/shop">
              Continue shopping
            </Link>
            <Link
              className="checkout-success-page__button checkout-success-page__button--secondary"
              to="/"
            >
              Return home
            </Link>
          </div>
        </section>
      </div>
    </main>
  );
};

export default PaySuccess;
